import React from 'react'
import { NavLink } from 'react-router-dom'
import { RedDot } from '../../components'
import { ChevronRight } from 'react-feather'

const NavItem = ({data}) => {
  return (
    <div className="nav-item rounded px-5 py-3 lg:py-5 flex justify-between items-center cursor-pointer">
      <div className="nav-item__content flex items-center">
        <div className="mr-3">
          {data.icon}
        </div>
        <div className="mr-1 text-sm" style={{textTransform: 'capitalize'}}>{data.label}</div>
        <div>{data.unread && <RedDot />}</div>
      </div>
      <div className="xl:hidden">
        <ChevronRight style={{color: '#999'}}/>
      </div>
    </div>
  )
}

const Sidebar = ({children, menu}) => {
  return (
    <div>
      {
        menu &&
        menu.map((m, i) => (
          <NavLink exact={m.exact} className="dashboard-nav-link" to={m.route} key={i}>
            <NavItem data={m}/>
          </NavLink>
        ))
      }
      {children}
    </div>
  )
}

export { Sidebar }
